import { autocompleteHistoryLSKey } from '../../../Assets/configuration/index.js';

export default function setHistorySuggestionsInternal(suggestions) {
  localStorage.setItem(autocompleteHistoryLSKey, JSON.stringify(suggestions ?? []));
}
